module.exports = __webpack_public_path__ + "assets/img/img-1.22af4416.png";